module Meevo.Components.Controls.HideInput {
    export const convertersList: { [key: string]: IStringConverterStatic } = {
        email: EmailStringConverter,
        phone: PhoneConverter
    };
}
